export default {
    REACT_APP_API_BASE: process.env.REACT_APP_API_BASE || 'https://evening-spire-23721.herokuapp.com/'
    }